export const LIST_CLAIMS = "LIST_CLAIMS";
export const LOADING_CLAIMS = "LOADING_CLAIMS";
export const ADD_CLAIM_SEARCH = "ADD_CLAIM_SEARCH";
export const SELECT_CLAIM = "SELECT_CLAIM";
export const RESET_FORM_CLAIM = "RESET_FORM_CLAIM";
export const LOADING_MODAL_CLAIM_DETAIL = "LOADING_MODAL_CLAIM_DETAIL";